<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [dismissableMask]="true"
  [showHeader]="false"
  (onHide)="close()"
  styleClass="how-it-works-dialog"
>
  <div class="how-it-works">
    <!-- Header -->
    <div class="header">
      <div class="header-icon">
        <i class="pi pi-question-circle"></i>
      </div>
      <h2 class="title">{{ 'HOW_MATCHMAKING_WORKS' | translate }}</h2>
      <p class="subtitle">{{ 'MATCHMAKING_SUBTITLE' | translate }}</p>
    </div>

    <!-- Timeline -->
    <div class="timeline">
      <!-- Step 1: Register -->
      <div class="step step-1">
        <div class="step-connector">
          <div class="step-dot">
            <i class="pi pi-play"></i>
          </div>
          <div class="step-line"></div>
        </div>
        <div class="step-content">
          <div class="step-number">01</div>
          <h3 class="step-title">{{ 'MATCHMAKING_STEP_1_TITLE' | translate }}</h3>
          <p class="step-desc">{{ 'MATCHMAKING_STEP_1_DESC' | translate }}</p>
          <!-- Mini illustration: single player icon -->
          <div class="step-visual visual-register">
            <div class="player-circle you">
              <i class="pi pi-user"></i>
            </div>
            <div class="visual-label">{{ 'YOU' | translate }}</div>
          </div>
        </div>
      </div>

      <!-- Step 2: We Search -->
      <div class="step step-2">
        <div class="step-connector">
          <div class="step-dot">
            <i class="pi pi-search"></i>
          </div>
          <div class="step-line"></div>
        </div>
        <div class="step-content">
          <div class="step-number">02</div>
          <h3 class="step-title">{{ 'MATCHMAKING_STEP_2_TITLE' | translate }}</h3>
          <p class="step-desc">{{ 'MATCHMAKING_STEP_2_DESC' | translate }}</p>
          <!-- Mini illustration: searching dots -->
          <div class="step-visual visual-search">
            <div class="player-circle you">
              <i class="pi pi-user"></i>
            </div>
            <div class="search-dots">
              <span class="dot dot-1"></span>
              <span class="dot dot-2"></span>
              <span class="dot dot-3"></span>
            </div>
            <div class="player-circle ghost">
              <i class="pi pi-user"></i>
            </div>
            <div class="player-circle ghost">
              <i class="pi pi-user"></i>
            </div>
            <div class="player-circle ghost">
              <i class="pi pi-user"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- Step 3: Match Found -->
      <div class="step step-3">
        <div class="step-connector">
          <div class="step-dot">
            <i class="pi pi-check-circle"></i>
          </div>
          <div class="step-line"></div>
        </div>
        <div class="step-content">
          <div class="step-number">03</div>
          <h3 class="step-title">{{ 'MATCHMAKING_STEP_3_TITLE' | translate }}</h3>
          <p class="step-desc">{{ 'MATCHMAKING_STEP_3_DESC' | translate }}</p>
          <!-- Mini illustration: 4 players grouped -->
          <div class="step-visual visual-matched">
            <div class="match-group">
              <div class="player-circle matched">
                <i class="pi pi-user"></i>
              </div>
              <div class="player-circle matched">
                <i class="pi pi-user"></i>
              </div>
              <div class="player-circle matched you">
                <i class="pi pi-user"></i>
              </div>
              <div class="player-circle matched">
                <i class="pi pi-user"></i>
              </div>
            </div>
            <div class="court-badge">
              <i class="pi pi-calendar"></i>
              <span>{{ 'AUTO_BOOKED' | translate }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Step 4: Play -->
      <div class="step step-4">
        <div class="step-connector">
          <div class="step-dot dot-final">
            <i class="pi pi-trophy"></i>
          </div>
        </div>
        <div class="step-content">
          <div class="step-number">04</div>
          <h3 class="step-title">{{ 'MATCHMAKING_STEP_4_TITLE' | translate }}</h3>
          <p class="step-desc">{{ 'MATCHMAKING_STEP_4_DESC' | translate }}</p>
          <!-- Mini illustration: notification bell -->
          <div class="step-visual visual-play">
            <div class="notif-card">
              <i class="pi pi-bell"></i>
              <div class="notif-lines">
                <span class="notif-line long"></span>
                <span class="notif-line short"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Divider -->
    <div class="section-divider">
      <span class="divider-label">{{ 'YOUR_PREFERENCES' | translate }}</span>
    </div>

    <!-- Preferences -->
    <div class="preferences">
      <div class="pref-card">
        <div class="pref-icon anyone-icon">
          <i class="pi pi-users"></i>
        </div>
        <div class="pref-info">
          <h4 class="pref-title">{{ 'Anyone' | translate }}</h4>
          <p class="pref-desc">{{ 'PREF_ANYONE_DESC' | translate }}</p>
        </div>
      </div>

      <div class="pref-card">
        <div class="pref-icon fav-icon">
          <i class="pi pi-star-fill"></i>
        </div>
        <div class="pref-info">
          <h4 class="pref-title">{{ 'Favorites Only' | translate }}</h4>
          <p class="pref-desc">{{ 'PREF_FAVORITES_DESC' | translate }}</p>
          <div class="pref-note">
            <i class="pi pi-info-circle"></i>
            <span>{{ 'PREF_FAVORITES_MIN' | translate }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="dialog-footer">
      <button
        pButton
        class="btn-got-it"
        [label]="'GOT_IT' | translate"
        (click)="close()"
      ></button>
    </div>
  </div>
</p-dialog>
